'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.core.notification.types.email', [])
  .config(function(notificationTypeConfigProvider) {
    notificationTypeConfigProvider.registerNotificationType({
      label: 'Email',
      key: 'email',
      addressTemplateUrl: require('./additionalFields.html'),
    });
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/notification/types/email/email.notification.type.module.js